import { render, staticRenderFns, recyclableRender, components } from "./jp-signature.vue?vue&type=template&id=241dcc82&filter-modules=eyJzaWduIjp7InR5cGUiOiJyZW5kZXJqcyIsImNvbnRlbnQiOiIiLCJzdGFydCI6MTg3NjEsImF0dHJzIjp7Im1vZHVsZSI6InNpZ24iLCJsYW5nIjoianMifSwiZW5kIjoxODgxNX19&"
var renderjs
import script from "./jp-signature.vue?vue&type=script&lang=js&"
export * from "./jp-signature.vue?vue&type=script&lang=js&"
import style0 from "./jp-signature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/jp-signature/components/jp-signature/jp-signature.vue"
export default component.exports